import React, { useEffect, useState } from "react";
import "./merchandiseMenu.css";
import arrowRight from "../../../../assets/arrow-right.png";
import arrowDown from "../../../../assets/arrow-down.png";
import arrowUp from "../../../../assets/arrow-up.png";
import { useSelector } from "react-redux";
import MerchandiseKit from "../merchandiseKit";
import MerchandiseItem from "../merchandiseItem";
import merchandiseIcon from "../../../../assets/u400c/merchandise.png";
import ComponentLoader from "../../../../components/componentLoader";
import { setCustomConfigData } from "../../../../redux/actions/custom-config-data-action";
import { useDispatch } from "react-redux";
import nodata from "../../../../assets/nodata.png";
import axios from "axios";
import { ConfigBaseUrl, VehicleCode } from "../../../../config";

const MerchandiseMenu = ({ onDrawer, infoModal, enableResetButton }) => {
  // const arr = [
  //   {
  //     Id: "8590382596417",
  //     ProductCode: "NF306248",
  //     ProductVariantCode: null,
  //     Name: "Cap1 - Black",
  //     Catogery: "Merchandise",
  //     ProductCatogery: "cap",
  //     ProductLink: "https://tvs-corporate-uat.myshopify.com/products/cap1",
  //     Description:
  //       "<p>As is the case with any product offering by TVS, the boundaries of functionality are -density inner EPS for greater impact absorption. Aerodynamic design to reduce drag , DOT &amp; ECE Certified. Washable padding with premium reflective strips for night-time visibility. Double D-Ring clip. Breath deflector that reduces fogging</p>",
  //     Images: [
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/3_5810ffad-297d-4d5d-ba09-0e31dafc760a.jpg?v=1693552860",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/4_9e09e446-8bbc-4d2c-9e05-181af36e3b6c.jpg?v=1693552860",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/2_a0789732-9c9a-4e15-a7ad-df43987f5291.jpg?v=1693552860",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/1_9762ebea-d112-4e1d-831e-3681818906d2.jpg?v=1693552860",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/9.png?v=1693552860",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/products/Frame5_aef2d801-dca6-40d7-ac9b-083082f0a26d.png?v=1693552860",
  //     ],
  //     MRP: "699",
  //     DiscountPercentage: "0.0",
  //     Price: "699",
  //     ListingPrice: "699",
  //     Discount: null,
  //     DiscountText: null,
  //     Quntity: 10,
  //     Color: "Black",
  //     Size: "",
  //     SizeChExternalCartLineIdartImageUrl: "",
  //     SizeChartImageUrl:
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/size-chart-tvsmotor.jpg",
  //     ColorImageUrl:
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/products/Frame5.png",
  //     Version: "",
  //     InventoryCount: 10,
  //     Variants: [],
  //   },
  //   {
  //     Id: "8590382399809",
  //     ProductCode: "NF306218",
  //     ProductVariantCode: null,
  //     Name: "Crew neck t-shirt - Yellow",
  //     Catogery: "Merchandise",
  //     ProductCatogery: "tshirt",
  //     ProductLink:
  //       "https://tvs-corporate-uat.myshopify.com/products/crew-neck-t-shirt",
  //     Description:
  //       "<p>As is the case with any product offering by TVS, the boundaries of functionality are -density inner EPS for greater impact absorption. Aerodynamic design to reduce drag , DOT &amp; ECE Certified. Washable padding with premium reflective strips for night-time visibility. Double D-Ring clip. Breath deflector that reduces fogging</p>",
  //     Images: [
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/a_20888ef4-fead-413d-9fc3-093ad09bfa86.jpg?v=1693552552",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/b_5e83d7f1-7224-452f-904e-e2d51cce386d.jpg?v=1693552552",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/6_61ccf201-29c9-40f9-a6b6-a914be953404.jpg?v=1693552552",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/5_8312e332-a608-4d80-8a8a-ab0c0f299bad.jpg?v=1693552552",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/4_18223043-3f3c-4aaa-a9d2-1f9755096c56.jpg?v=1693552552",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/3_ac4a9f02-3f6f-44e7-8422-fc24df601786.jpg?v=1693552552",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/2.2_ec59d1e7-5dff-4b0c-8274-88ca1d1276c7.jpg?v=1693552552",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/1_a89932d5-4bf9-4941-8708-6d08f85b0c8b.jpg?v=1693552552",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/products/3.png?v=1693552552",
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/products/Frame4_96af28a1-189a-4839-afbf-ba0a36c928f9.png?v=1693552552",
  //     ],
  //     MRP: "",
  //     DiscountPercentage: "0.0",
  //     Price: "",
  //     ListingPrice: "",
  //     Discount: null,
  //     DiscountText: null,
  //     Quntity: 0,
  //     Color: "",
  //     Size: "",
  //     SizeChExternalCartLineIdartImageUrl: "",
  //     SizeChartImageUrl:
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/size-chart-tvsmotor.jpg",
  //     ColorImageUrl:
  //       "https://cdn.shopify.com/s/files/1/0808/2908/8065/products/Frame4_96af28a1-189a-4839-afbf-ba0a36c928f9.png",
  //     Version: "",
  //     Variants: [
  //       {
  //         Id: "",
  //         ProductCode: "NF306218",
  //         ProductVariantCode: "",
  //         Name: "Crew neck t-shirt - Yellow",
  //         Catogery: "",
  //         Description: "",
  //         Images: "",
  //         MRP: "799",
  //         ListingPrice: "799",
  //         Price: "799",
  //         Quntity: 12,
  //         InventoryCount: 10,
  //         Color: "Yellow",
  //         Size: "S",
  //         PersonalizeText: "",
  //         SizeChartImageUrl:
  //           "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/size-chart-tvsmotor.jpg",
  //         ColorImageUrl:
  //           "https://cdn.shopify.com/s/files/1/0808/2908/8065/products/Frame4_96af28a1-189a-4839-afbf-ba0a36c928f9.png",
  //         ExternalCartLineId: "",
  //         Version: "",
  //       },
  //       {
  //         Id: "",
  //         ProductCode: "NF306219",
  //         ProductVariantCode: "",
  //         Name: "Crew neck t-shirt - Yellow",
  //         Catogery: "",
  //         Description: "",
  //         Images: "",
  //         MRP: "0",
  //         ListingPrice: "799",
  //         Price: "0",
  //         Quntity: 0,
  //         InventoryCount: 12,
  //         Color: "Yellow",
  //         Size: "M",
  //         PersonalizeText: "",
  //         SizeChartImageUrl:
  //           "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/size-chart-tvsmotor.jpg",
  //         ColorImageUrl:
  //           "https://cdn.shopify.com/s/files/1/0808/2908/8065/products/Frame4_96af28a1-189a-4839-afbf-ba0a36c928f9.png",
  //         ExternalCartLineId: "",
  //         Version: "",
  //       },
  //       {
  //         Id: "",
  //         ProductCode: "NF306220",
  //         ProductVariantCode: "",
  //         Name: "Crew neck t-shirt - Yellow",
  //         Catogery: "",
  //         Description: "",
  //         Images: "",
  //         MRP: "799",
  //         ListingPrice: "799",
  //         Price: "",
  //         Quntity: 10,
  //         InventoryCount: 10,
  //         Color: "Yellow",
  //         Size: "L",
  //         PersonalizeText: "",
  //         SizeChartImageUrl:
  //           "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/size-chart-tvsmotor.jpg",
  //         ColorImageUrl:
  //           "https://cdn.shopify.com/s/files/1/0808/2908/8065/products/Frame4_96af28a1-189a-4839-afbf-ba0a36c928f9.png",
  //         ExternalCartLineId: "",
  //         Version: "",
  //       },
  //       {
  //         Id: "",
  //         ProductCode: "NF306221",
  //         ProductVariantCode: "",
  //         Name: "Crew neck t-shirt - Yellow",
  //         Catogery: "",
  //         Description: "",
  //         Images: "",
  //         MRP: "799",
  //         ListingPrice: "799",
  //         Price: "0",
  //         Quntity: 0,
  //         InventoryCount: 10,
  //         Color: "Yellow",
  //         Size: "XL",
  //         PersonalizeText: "",
  //         SizeChartImageUrl:
  //           "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/size-chart-tvsmotor.jpg",
  //         ColorImageUrl:
  //           "https://cdn.shopify.com/s/files/1/0808/2908/8065/products/Frame4_96af28a1-189a-4839-afbf-ba0a36c928f9.png",
  //         ExternalCartLineId: "",
  //         Version: "",
  //       },
  //       {
  //         Id: "",
  //         ProductCode: "NF306222",
  //         ProductVariantCode: "",
  //         Name: "Crew neck t-shirt - Yellow",
  //         Catogery: "",
  //         Description: "",
  //         Images: "",
  //         MRP: "799",
  //         ListingPrice: "799",
  //         Price: "799",
  //         Quntity: 10,
  //         InventoryCount: 10,
  //         Color: "Yellow",
  //         Size: "XXL",
  //         PersonalizeText: "",
  //         SizeChartImageUrl:
  //           "https://cdn.shopify.com/s/files/1/0808/2908/8065/files/size-chart-tvsmotor.jpg",
  //         ColorImageUrl:
  //           "https://cdn.shopify.com/s/files/1/0808/2908/8065/products/Frame4_96af28a1-189a-4839-afbf-ba0a36c928f9.png",
  //         ExternalCartLineId: "",
  //         Version: "",
  //       },
  //     ],
  //   },
  // ];
  const [accessoriesExpand, setAccessoriesExpand] = useState(true);
  const [merchandiseData, setMerchandiseData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [merchandiseTitle, setMerchandiseTitle] = useState("");
  const customConfigData = useSelector((state) => state.customConfigData.data);

  const dispatch = useDispatch();

  useEffect(() => {
    try {
      setLoader(true);

      if (customConfigData?.merchandise) {
        setMerchandiseData(customConfigData?.merchandise);
        setMerchandiseTitle(customConfigData?.merchandise[0]?.Catogery);
        setLoader(false);
      } else {
        axios({
          method: "post",
          url: ConfigBaseUrl() + "accessoriesUat",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {
            categoryType: ["Merchandise"],
            categoryCode: [],
            genderfacet: [],
            segment: [],
            colorfacet: "",
            vehicleCode: VehicleCode,
            pageNumber: 0,
            pageSize: 100,
          },
        }).then((res) => {
          const data = res.data;
          if (data?.status === "success") {
            const merchandiseArrData = data?.data?.filter(
              (el) => el.Catogery === "Merchandise"
            );

            setMerchandiseData(merchandiseArrData);
            setMerchandiseTitle(merchandiseArrData[0]?.Catogery);

            customConfigData["merchandise"] = merchandiseArrData;
            dispatch(setCustomConfigData(structuredClone(customConfigData)));
            setLoader(false);
          } else {
            setLoader(false);
          }
        });
      }
    } catch (error) {
      setLoader(false);
    } finally {
    }
  }, [customConfigData]);

  const onAddMerchandise = (
    name,
    productCode,
    price,
    catogery,
    counter,
    color,
    personalizeText,
    mrp,
    discount,
    image,
    size
  ) => {
    const hasProductId = customConfigData?.orderDetails?.some(
      (item) => item.ProductId === productCode
    );
    enableResetButton(true);
    if (!hasProductId) {
      customConfigData?.orderDetails.push({
        ProductName: name,
        ProductId: productCode,
        VariantId: productCode,
        Quantity: counter,
        Price: parseInt(price?.replace(/,/g, "")) * parseInt(counter),
        ProductImageurl: image,
        MRP: parseInt(mrp?.replace(/,/g, "")) * parseInt(counter),
        DiscountPercentage: discount,
        Colour: color,
        PersonalizeText: personalizeText,
        Type: catogery,
        Size: size,
      });
    }
  };

  const onDeleteMerchandise = (partNumber) => {
    const hasProductId = customConfigData?.orderDetails?.some(
      (item) => item.ProductId === partNumber
    );

    const merchandiseCartStatus = customConfigData?.merchandise?.some(
      (element) => {
        return element["cartStatus"] === true;
      }
    );

    const combopackCartStatus = customConfigData?.comboPack?.some((element) => {
      return element?.data?.some((elem) => {
        return elem["cartStatus"] === true;
      });
    });

    const accessoriesCartStatus = customConfigData?.accessoriesData?.some(
      (element) => {
        return element?.data?.some((elem) => {
          return elem["cartStatus"] === true;
        });
      }
    );

    const kitStatus = customConfigData?.kits?.some((item) => {
      return item["status"] === true;
    });
    if (hasProductId) {
      customConfigData.orderDetails.splice(
        customConfigData.orderDetails.findIndex(
          (item) => item.ProductId === partNumber
        ),
        1
      );
    }
    if (
      merchandiseCartStatus ||
      combopackCartStatus ||
      accessoriesCartStatus ||
      kitStatus
    ) {
      enableResetButton(true);
    } else {
      enableResetButton(false);
    }
  };

  const onCart = (
    name,
    price,
    partNumber,
    category,
    status,
    counter,
    color,
    personalizeText,
    mrp,
    discount,
    image,
    size
  ) => {
    customConfigData?.merchandise?.map((element) => {
      if (element.ProductCode === partNumber) {
        element.cartStatus = status;
        element.countValue = counter;
      }
    });

    if (status) {
      onAddMerchandise(
        name,
        partNumber,
        price,
        category,
        counter,
        color,
        personalizeText,
        mrp,
        discount,
        image,
        size
      );
    } else {
      onDeleteMerchandise(partNumber);
    }

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  return (
    <div className="merchandise_modal">
      <div className="merchandise_container">
        <div
          className="nav_close"
          onClick={() => {
            onDrawer();
          }}
        >
          <img className="nav_close_icon" src={arrowRight} />
        </div>

        {loader || !merchandiseTitle ? (
          <ComponentLoader color={"#FFE100"} />
        ) : (
          <div className="config_category">
            <MerchandiseItem
              image={merchandiseIcon}
              label={merchandiseTitle}
              // desc={"Lorem ipsum dolor sit amet, consectetur"}
              arrowIcon={accessoriesExpand ? arrowUp : arrowDown}
              onClick={() => {
                setAccessoriesExpand(!accessoriesExpand);
              }}
            />

            {/* {accessoriesExpand &&
              arr?.map((item, index) => (
                <>
                  {hasData === false ? (
                    <>
                      <div className="merchandise_data_notFound">
                        <div className="no_data_img_div">
                          <img src={nodata} className="no_data_img" alt="" />
                        </div>
                        <div
                          style={{ marginTop: "1rem", marginLeft: "1rem" }}
                          className="mediumFont"
                        >
                          No results found
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <MerchandiseKit
                        item={item}
                        handleInfoModal={(item) => infoModal(item)}
                        onCart={onCart}
                        // add={item?.cartStatus}
                        // countValue={item?.cartStatus ? item?.countValue : 1}
                      />
                    </>
                  )}

  
                </>
              ))} */}

            {accessoriesExpand ? (
              merchandiseData?.length > 0 ? (
                merchandiseData?.map((item) => (
                  <>
                    <MerchandiseKit
                      item={item}
                      handleInfoModal={(item) => infoModal(item)}
                      onCart={onCart}
                      // add={item?.cartStatus}
                      // countValue={item?.cartStatus ? item?.countValue : 1}
                    />
                    {/* <MerchandiseItem
                  image={safetyIcon}
                  label={item?.category}
                  desc={item?.description}
                  arrowIcon={
                    indexVal === index && toggleArrow ? arrowUp : arrowDown
                  }
                  onClick={() => {
                    setToggleArrow(
                      indexVal === index && toggleArrow ? false : true
                    );
                    setIndexVal(index);
                  }}
                />
                {indexVal === index && toggleArrow && <MerchandiseKit />} */}
                  </>
                ))
              ) : (
                <>
                  <div className="merchandise_data_notFound">
                    <div className="no_data_img_div">
                      <img src={nodata} className="no_data_img" alt="" />
                    </div>
                    <div
                      style={{ marginTop: "1rem", marginLeft: "1rem" }}
                      className="mediumFont"
                    >
                      No results found
                    </div>
                  </div>
                </>
              )
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default MerchandiseMenu;
